import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

// The Layout card's body on the Test UI Components page (#6020): grids, item groups, form fields,
// card titles, tab panes and the floating action button.
@Component({
  selector: 'cs-test-layout-card',
  host: { class: 'showcase-card-body' },
  templateUrl: 'cs-test-layout-card.html',
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CsTestLayoutCardComponent {
  // the cs-form-field's text; the page shares it with the Control Outlines card's rest-state cs-input
  @Input() sampleText = '';
  @Output() sampleTextChange = new EventEmitter<string>();

  showcaseTab = 'first';
}
